<template>
  <div class="d-flex justify-content-end">
    <div>
      <McTableFilter
        :activeFilters="activeFilters"
        :parseFilterDataMappings="parseFilterDataMappings"
        @submit="handleInput"
        @reset="handleReset"
      >
        <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
          <div class="mc-modal__filter-item">
            <FormulateInput
              v-model="period"
              name="period"
              isShow="true"
              :label="$t('global.field.date')"
              :placeholder="`${$t('global.form.select')} ${$t('global.field.date')}`"
              type="date-picker"
              datepickerType="datetime"
              valueType="YYYY-MM-DDTHH:mm:ss.SSSZ"
              format="DD MMM YYYY HH:mm"
              titleFormat="DD MMM YYYY"
              rangeSeparator=" - "
              :range="true"
              :draft="true"
              :confirm="true"
              :confirmText="$t('global.action.apply')"
              :shortcuts="makeShortcuts"
              :disabled-date="disabledRange"
              :value="formValues.period || defaultPeriod"
              @pick="pickDate"
              @close="closePicker"
            />
          </div>
          <div class="mc-modal__filter-item">
            <FormulateInput
              v-bind="vehicleFields"
              :fullObject="fullObjects['licensePlate']"
              :value="formValues.licensePlate"
              @update:formValues="updateFormValues({ key: 'licensePlate', value: $event })"
              @update:fullObject="updateFullObjects({ key: 'licensePlate', value: $event })"
            />
          </div>
          <div class="mc-modal__filter-item">
            <FormulateInput
              v-bind="geofenceFields"
              :fullObject="fullObjects['geofence']"
              :value="formValues.geofence"
              @update:formValues="updateFormValues({ key: 'geofence', value: $event })"
              @update:fullObject="updateFullObjects({ key: 'geofence', value: $event })"
            />
          </div>
        </template>
      </McTableFilter>
    </div>
  </div>
</template>

<script>
import McTableFilter from '@/components/McTableFilter'
import { GET_VEHICLE_FILTER } from '@/services/api/master/fleet'
import { GET_GEOFENCES_FILTER } from '@/services/api/master/geofence'
import moment from 'moment'

export default {
  components: {
    McTableFilter,
  },

  props: {
    activeFilters: {
      required: true,
    },
    handleChangeActiveFilters: {
      type: Function,
    },
    isSelected: {},
  },

  data() {
    return {
      selectedDays: [],
      period: [
        moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      ],
      pastDate: moment().subtract(12, 'months'),
      futureEnd: moment().add(6, 'months'),
      currentPastDate: moment().subtract(12, 'months'),
      currentFutureEnd: moment().add(6, 'months'),
    }
  },

  computed: {
    defaultPeriod() {
      return [
        moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      ]
    },
    vehicleFields() {
      const tableFields = [
        {
          label: this.$t('report.fields.licensePlate'),
          key: 'licensePlate',
          isSortable: true,
        },
        {
          label: this.$t('global.field.vehicleType'),
          key: 'vehicleType',
          formatter(val) {
            const label = [val.category, val.model, val.type]
            return label.filter((x) => x !== null).join('/')
          },
          isSortable: false,
        },
      ]
      return {
        name: 'licensePlate',
        isShow: true,
        label: this.$t('report.fields.licensePlate'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.licensePlate')}`,
        trackBy: 'id',
        displayedBy: 'licensePlate',
        listGetter: (filter) => this.getVehicleList(filter),
        multiple: true,
        tableFields: tableFields,
      }
    },
    geofenceFields() {
      const tableFields = [
        {
          label: this.$t('global.object.geofence'),
          key: 'fenceName',
        },
        {
          label: this.$t('global.object.locationDetail'),
          key: 'address',
        },
        {
          label: this.$t('global.object.province'),
          key: 'province',
        },
        {
          label: this.$t('global.object.city'),
          key: 'city',
        },
      ]
      return {
        name: 'geofence',
        isShow: true,
        label: this.$t('global.object.geofence'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('global.object.geofence')}`,
        trackBy: 'id',
        displayedBy: 'fenceName',
        listGetter: (filter) => this.getGeofenceList(filter),
        multiple: true,
        tableFields: tableFields,
      }
    },
    makeShortcuts() {
      return [
        {
          text: this.$t('global.time.today'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setHours(0, 0, 0, 0)
            endDate.setHours(23, 59, 59, 0)

            return [startDate, endDate]
          },
        },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 1)
            startDate.setHours(0, 0, 0, 0)

            endDate.setDate(endDate.getDate() - 1)
            endDate.setHours(23, 59, 59, 0)

            return [startDate, endDate]
          },
        },
        {
          text: this.$t('global.time.last7Days'),
          onClick: () => {
            const endDate = new Date()
            const startDate = new Date()

            startDate.setDate(startDate.getDate() - 6)
            startDate.setHours(0, 0, 0, 0)

            endDate.setHours(23, 59, 59, 0)

            return [startDate, endDate]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },

    parseFilterDataMappings() {
      return {
        period: 'period',
        licensePlate: 'vehicleIds',
        geofence: 'geofenceIds',
      }
    },
  },

  created() {
    this.$nextTick(() => {
      this.$emit('update:formValues', { key: 'period', value: this.defaultPeriod })
    })
  },

  methods: {
    disabledRange: function (date) {
      let limit = new Date()
      return (
        date <= this.pastDate ||
        date >= this.futureEnd ||
        date <= this.currentPastDate ||
        date >= this.currentFutureEnd ||
        date > limit
      )
    },
    pickDate(date) {
      const maxDate = 7
      this.currentPastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000) == new Date()) {
        this.currentFutureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.currentFutureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
    closePicker() {
      this.currentPastDate = moment().subtract(6, 'months')
      this.currentFutureEnd = moment().add(6, 'months')
    },
    async getVehicleList(opt) {
      const { orderBy, ...otherOpt } = opt
      const self = this
      const response = await this.$apollo.query({
        query: GET_VEHICLE_FILTER,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            status: ['I', 'R', 'A'],
            orderBy: orderBy ?? JSON.stringify({ licensePlate: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.vehiclesFilter.vehiclesFilterPaginated }
      res.data = res.data.map((item) => {
        let status = ''
        if (item.status === 'I') {
          status = self.$t('master.status.aktif')
        } else if (item.status === 'R') {
          status = self.$t('master.status.perbaikan')
        } else {
          status = self.$t('master.status.arsip')
        }
        return Object.assign({}, item, { statusString: status })
      })
      return res
    },
    async getGeofenceList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_GEOFENCES_FILTER,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            orderBy: orderBy ?? JSON.stringify({ fenceName: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.geofencesFilter.geofencesFilterPaginated }
      res.data = res.data.map((item) => {
        return {
          ...item,
          id: item.geofenceId,
        }
      })
      return res
    },
    handleInput(value) {
      const periodItem = value.find((item) => item.key === 'period')
      if (periodItem.values && periodItem.values[0] === null && periodItem.values[1] === null) {
        value = value.map((item) => {
          if (item.key === 'period') {
            return {
              ...item,
              values: this.defaultPeriod,
            }
          }
          return item
        })
      }
      const startTime = value.find((item) => item.key === 'startTime')?.values
      const endTime = value.find((item) => item.key === 'endTime')?.values

      if (startTime && endTime && startTime > endTime) {
        this.$mcToast.error(this.$t('setting.cutOffAutomation.error.endTimeGreaterThanStartTime'))
        return false
      }

      const updatedValue = value.map((item) => {
        const { key, values } = item

        return {
          ...item,
          values:
            key === 'vgroup' && values
              ? values.map((val) => parseInt(val, 10))
              : key === 'days' && values
              ? this.selectedDays
              : key === 'status' && !values
              ? 'all'
              : values,
        }
      })

      this.$emit('handleChangeActiveFilters', updatedValue)
    },
    handleReset() {
      this.period = this.defaultPeriod
    },
  },
}
</script>
